import { Switch } from 'antd';
import React from 'react';

import { ICommonInputProps } from './types';

const SwitchInput: React.FC<ICommonInputProps> = ({ disabled, defaultValue, inputClassName, onChange, value }) => (
  <Switch
    disabled={disabled}
    className={`switch-input ${inputClassName}`}
    checked={!!value}
    defaultChecked={!!defaultValue}
    onChange={onChange}
  />
);

export default React.memo(SwitchInput);
